import {
  CheckRounded,
  CloseRounded,
  EmojiEventsRounded,
  EmojiObjectsRounded,
  LocalLibraryRounded,
  WorkspacePremiumRounded,
} from "@mui/icons-material";
import FlashReportNav from "../NavBar/FlashReportNav";
import Footer from "../Footer/ReportFooter";
import { EVALOPTIONS } from "../../../context/initialValues";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const MainResultsCard = ({ color, value, label }) => {
  const STYLES = {
    yellow: {
      color: "var(--gold)",
      backgroundColor: "var(--ghostGold)",
    },
    purple: {
      color: "var(--purple)",
      backgroundColor: "var(--ghostPurple)",
    },
    red: {
      color: "var(--red)",
      backgroundColor: "var(--ghostRed)",
    },
  };

  return (
    <div style={STYLES[color] || {}} className="main-result-card">
      <h2>{value}</h2>
      <small>{label}</small>
    </div>
  );
};

const StudyRow = ({ evalStatus, customDisplayText = "" }) => {
  const options = {
    [EVALOPTIONS["STILLSTUDYING"]]: {
      class: "study-row",
      icon: <LocalLibraryRounded color="inherit" />,
    },
    [EVALOPTIONS["MASTERED"]]: {
      class: "mastered-row",
      icon: <WorkspacePremiumRounded color="inherit" />,
    },
    [EVALOPTIONS["ALWAYSRIGHT"]]: {
      class: "always-right-row",
      icon: <EmojiEventsRounded color="inherit" />,
    },
    [EVALOPTIONS["ALMOSTTHERE"]]: {
      class: "almost-row",
      icon: <EmojiObjectsRounded color="inherit" />,
    },
  };

  return (
    <div className={options[evalStatus].class}>
      {options[evalStatus].icon}
      <p className="mb-0">{customDisplayText || evalStatus}</p>
    </div>
  );
};

const ReportFlashCard = ({ content, questionPosition }) => {
  const isStatusAlmostThere = content.status === EVALOPTIONS.ALMOSTTHERE;
  return (
    <div className="eval-card-container">
      <div className="flash-results-card">
        <div className="results-header">
          <p>
            <b>Card {questionPosition}</b>
          </p>
          {content.wasCorrect ? (
            <p>
              <CheckRounded
                color="success"
                sx={{ marginRight: "0.5" }}
                fontSize="small"
              />{" "}
              1 / 1 pts
            </p>
          ) : (
            <p>
              <CloseRounded
                color="error"
                sx={{ marginRight: "0.5" }}
                fontSize="small"
              />{" "}
              0 / 1 pts
            </p>
          )}
        </div>

        <p className="results-question-content mb-0"> {content.question}</p>
      </div>
      <StudyRow
        evalStatus={content.status}
        customDisplayText={
          isStatusAlmostThere
            ? `Master in ${content.studyAmount} more ${content.studyAmount > 1 ? "tries" : "try"}`
            : ""
        }
      />
    </div>
  );
};

const CardsReport = ({
  cardsTotal,
  correctCount,
  wrongCount,
  exitedStudyPileCount,
  cardHistory,
  hintCount,
}) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 670);
  const cardData = [
    { color: "yellow", value: exitedStudyPileCount, label: "Mastered Cards" },
    { color: "purple", value: hintCount, label: "Revealed Hints" },
    { color: "red", value: wrongCount, label: "Incorrect Cards" },
  ];
  const renderCards = (wrapInSlide = false) =>
    cardData.map((card, index) =>
      wrapInSlide ? (
        <SwiperSlide key={index}>
          <MainResultsCard {...card} />
        </SwiperSlide>
      ) : (
        <MainResultsCard key={index} {...card} />
      ),
    );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 670);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function goHome() {
    navigate("/flashcards");
  }

  function retry() {
    window.location.reload();
  }
  return (
    <div className="page page-col flash-report">
      <FlashReportNav totalCorrect={correctCount} total={cardsTotal} />
      <div className="report-flash-container">
        {isMobile ? (
          <div className="mobile-carousel-wrapper">
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 2000, disableOnInteraction: false }}
              spaceBetween={10}
              slidesPerView={1}
              style={{ height: "100%" }}
              breakpoints={{
                670: { slidesPerView: 2 },
                495: { slidesPerView: 1 },
              }}
            >
              {renderCards(true)}
            </Swiper>
          </div>
        ) : (
          <div className="main-results-container">{renderCards(false)}</div>
        )}

        <div className="report-list-container">
          {cardHistory.map((item, idx) => (
            <ReportFlashCard
              questionPosition={idx + 1}
              content={item}
              key={`card-report-${idx}`}
            />
          ))}
        </div>
      </div>
      <Footer onHomeClick={goHome} onRetryClick={retry} />
    </div>
  );
};

export default CardsReport;
